import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { DataService } from '../../services/data.service';

declare const reviewsBadgeModern: any;

@Component({
    selector: 'app-full-layout',
    templateUrl: './full.component.html',
    styleUrls: ['./full.component.scss'],
})
export class FullComponent implements OnInit, OnDestroy {
    showHero = false;
    private routeSub?: Subscription;

    constructor(
        private apiService: ApiService,
        private dataService: DataService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
    ) {}

    ngOnInit() {
        this.showHero = this.readShowHero();
        this.routeSub = this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                map(() => this.activatedRoute),
                map((route) => {
                    while (route.firstChild) {
                        route = route.firstChild;
                    }
                    return route;
                }),
                mergeMap((route) => route.data),
            )
            .subscribe((data) => {
                this.showHero = data['showHero'] === true;
                if (!this.showHero) {
                    this.dataService.setMembershipTab('covered');
                }
            });

        reviewsBadgeModern('badge-230', {
            store: 'harry-hall',
            primaryClr: '#202440',
            starsClr: '#0076a5',
        });

        const w = window as any;
        const previousReady = w.$zoho?.salesiq?.ready;
        w.$zoho = w.$zoho || {};
        w.$zoho.salesiq = w.$zoho.salesiq || {};
        w.$zoho.salesiq.ready = () => {
            if (typeof previousReady === 'function') {
                previousReady();
            }
            w.$zoho.salesiq.floatbutton?.click?.(() => this.onOffSiteClick('chat-box'));
            w.$zoho.salesiq.visitor?.callback?.(() => this.onOffSiteClick('callback-form'));
        };
    }

    ngOnDestroy() {
        this.routeSub?.unsubscribe();
    }

    private readShowHero(): boolean {
        let route = this.activatedRoute;
        while (route.firstChild) {
            route = route.firstChild;
        }
        return route.snapshot.data['showHero'] === true;
    }

    onOffSiteClick(url: string) {
        const email = this.dataService.getQuote()?.email;
        console.log('offsiteclick');
        if (email) {
            this.apiService.klaviyoSendEvent({ type: 'off-site', url, email }).subscribe();
        }
    }
}
